import { Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { EInvoicesKYCPendingStatus } from '../../../../assets/images'
import { EInvoicingGenericStatus } from '../EInvoicingGenericStatus'

export const EInvoicingKYCPending = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <EInvoicingGenericStatus
      title={t('e_invoice.kyc.step.status.pending.title')}
      illustration={EInvoicesKYCPendingStatus}
    >
      <Text alignment="center">
        <Trans i18nKey="e_invoice.kyc.step.status.pending.subtitle" components={{ strong: <strong /> }} />
      </Text>
      <Space size="s16" />
      <Text colorVariant="secondary" alignment="center">
        {t('e_invoice.kyc.step.status.pending.footer')}
      </Text>
    </EInvoicingGenericStatus>
  )
}
